import { gql } from '@apollo/client';

export const LOGIN_STATUS = gql`
  query {
    loginStatus {
      loggedIn
      redirectTo
      email
      accountType
    }
  }
`;
